import { customTV } from '../../utils/tailwind';
import { TYPOGRAPHY_VARIANTS } from '../Typography/styles';
export { affix, input, inputCentralizer, inputLabel, inputWrapper, } from '../TextField/styles';
export const listSection = customTV({
    base: 'list-style-none max-h-[15rem] overflow-y-auto p-0 outline-none',
});
export const listBox = customTV({
    extend: listSection,
    base: 'shadow-low bg-background-overlay dark:bg-background-overlay-dark mx-2 mt-4 rounded-sm flex flex-col',
    variants: {
        loading: {
            true: 'justify-center p-16',
        },
    },
});
export const listItem = customTV({
    base: [
        'text-content-default dark:text-content-default-dark cursor-pointer px-12 py-16 outline-none outline-0',
        TYPOGRAPHY_VARIANTS.body,
    ],
    variants: {
        selected: { false: '' },
        focused: { false: '' },
        disabled: {
            true: 'text-content-disabled dark:text-content-disabled-dark bg-background-contrast dark:bg-background-contrast-dark',
        },
    },
    compoundVariants: [
        {
            selected: true,
            focused: false,
            disabled: false,
            className: 'bg-background-selected dark:bg-background-selected-dark',
        },
        {
            focused: true,
            disabled: false,
            className: 'bg-background-hover dark:bg-background-hover-dark',
        },
    ],
});
